// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseImageUrl from "@insite/client-framework/Common/Utilities/parseImageUrl";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import cssProp from "@toolkit/Framework/Common/Utilities/cssProp";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC, useMemo } from "react";
import { css } from "styled-components";

const enum fields {
    padding = "padding",
    image = "image",
    roundedEdges = "roundedEdges",
    testSelectorId = "testSelectorId",
}
export interface OwnProps extends WidgetProps {
    fields: {
        [fields.image]: string;
        [fields.testSelectorId]: string;
        [fields.padding]: string;
        [fields.roundedEdges]: boolean;
    };
}

type Props = OwnProps;

export interface MarketingBannerStyles {
    wrapper: InjectableCss;
    contentGridContainer?: GridContainerProps;
    contentGridItem?: GridItemProps;
}

export const marketingBannerStyles: MarketingBannerStyles = {
    wrapper: {
        css: css`
            padding: ${pxToRem(16)};
            background-size: cover;
            background-position: center;
        `,
    },
    contentGridItem: {
        width: [12, 8, 6, 5, 5],
    },
};

const MarketingBanner: FC<Props> = ({ id, fields }: Props) => {
    const styles = useMemo(() => {
        return mergeProps<MarketingBannerStyles>(marketingBannerStyles, {
            wrapper: {
                css: css`
                    ${fields.roundedEdges && `border-radius: 10px;`}
                    ${cssProp("background-image", fields.image, x => `url(${parseImageUrl(x).url})`)}

                ${breakpoint("sm")} {
                        padding: ${pxToRem(fields.padding)};
                    }
                `,
            },
        });
    }, [fields.padding, fields.image, fields.roundedEdges]);

    return (
        <StyledWrapper {...styles.wrapper} data-test-selector={fields.testSelectorId}>
            <GridContainer {...styles.contentGridContainer}>
                <GridItem {...styles.contentGridItem}>
                    <Zone contentId={id} zoneName="Content" />
                </GridItem>
            </GridContainer>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: MarketingBanner,
    definition: {
        group: "Basic",
        displayName: "Marketing Banner",
        icon: "image-landscape",
        fieldDefinitions: [
            {
                name: fields.image,
                displayName: "Image",
                editorTemplate: "ImagePickerField",
                fieldType: "Contextual",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.padding,
                displayName: "Padding",
                editorTemplate: "IntegerField",
                defaultValue: 20,
            },
            {
                fieldType: "General",
                name: fields.roundedEdges,
                displayName: "Rounded Edges",
                editorTemplate: "CheckboxField",
                defaultValue: false,
            },
            {
                name: fields.testSelectorId,
                displayName: "Test Selector ID",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
